import {
    Service,
    ServiceOption,
    ServiceOptionLocation,
    ServiceOptionPage,
    ServiceOptionStatus,
    ServiceOptionVehicle,
} from '../../../serviceOrders/serviceOptions/serviceOption.types';
import { parseStringDate } from '../../../sharedComponents/dateHelper';
import {
    ApiServiceOption,
    ApiServiceOptionLocation,
    ApiServiceOptionPage,
    ApiServiceOptionService,
    ApiServiceOptionStatus,
} from '../../types/serviceOrder/serviceOptionsApi.types';
import { ApiServiceVehicle } from '../../types/serviceOrder/serviceVehicleApi.types';
import { mapToPartialAddress } from '../addressMappers';
import { mapToTimeZone } from '../timeZoneMappers';
import { mapToVehicleId } from '../sharedVehicleMappers';
import { mapToServiceType } from './serviceTypeMapper';
import { mapToServiceVehicleModel } from './serviceVehicleMapper';

export const mapToServiceOptionStatus = (apiServiceOptionStatus: ApiServiceOptionStatus): ServiceOptionStatus => {
    switch (apiServiceOptionStatus) {
        case ApiServiceOptionStatus.OPEN:
            return ServiceOptionStatus.OPEN;
        case ApiServiceOptionStatus.CLOSED:
            return ServiceOptionStatus.CLOSED;
        case ApiServiceOptionStatus.CANCELLED:
            return ServiceOptionStatus.CANCELLED;
    }
};

export const mapToServiceOptionVehicle = (apiServiceOptionVehicle: ApiServiceVehicle): ServiceOptionVehicle => ({
    id: mapToVehicleId(apiServiceOptionVehicle.id),
    model: apiServiceOptionVehicle.model && mapToServiceVehicleModel(apiServiceOptionVehicle.model),
});

export const mapToServiceOptionServices = (apiServiceOptionService: ApiServiceOptionService): Service => ({
    type: mapToServiceType(apiServiceOptionService.type),
    description: apiServiceOptionService.description,
    executionCount: apiServiceOptionService.execution_count,
});

export const mapToServiceOptionLocation = (apiLocation: ApiServiceOptionLocation): ServiceOptionLocation => ({
    timeZone: mapToTimeZone(apiLocation.time_zone),
    identifier: apiLocation.identifier,
    address: apiLocation.address ? mapToPartialAddress(apiLocation.address) : undefined,
});

export const mapToServiceOption = (apiServiceOption: ApiServiceOption): ServiceOption => ({
    id: apiServiceOption.id,
    externalOrderId: apiServiceOption.external_order_id,
    status: mapToServiceOptionStatus(apiServiceOption.status),
    vehicle: mapToServiceOptionVehicle(apiServiceOption.vehicle),
    orderIssuedAt: parseStringDate(apiServiceOption.order_issued_at),
    services: apiServiceOption.services.map(mapToServiceOptionServices),
    serviceLocation: mapToServiceOptionLocation(apiServiceOption.service_location),
});

export const mapToServiceOptions = (apiServiceOptionPage: ApiServiceOptionPage): ServiceOptionPage => ({
    items: apiServiceOptionPage.items.map(mapToServiceOption),
    hasMore: apiServiceOptionPage.has_more,
});
